import { Routes } from '@angular/router';
import { signedOutGuard } from '../../core/auth/auth.guard';
import { APP_PATHS } from '../../core/routing/app-paths';

/** Public routes, outside the app shell. */
export const AUTH_ROUTES: Routes = [
  {
    path: APP_PATHS.login,
    canActivate: [signedOutGuard],
    loadComponent: () => import('./sign-in.component').then((m) => m.SignInComponent),
    title: 'Sign in | Sales Portal',
  },
];
